import { createPaginationEntity } from '@luna/api';

import { fetchAccount, fetchAccountListPage } from './services';
import { updateAccount } from './services/accountsEntityService';

export const {
    useEntity: useAccount,
    useEntities: useAccounts,
    entityHelpers: accountsEntityHelpers,
} = createPaginationEntity({
    name: '@products/aggregation/accounts',
    payloadCreators: {
        queryById: fetchAccount,
        queryPage: fetchAccountListPage,
        updateById: updateAccount,
    },
});
